import { render, staticRenderFns } from "./ThemeSettingsDirectTop2.vue?vue&type=template&id=553549d2&scoped=true"
import script from "./ThemeSettingsDirectTop2.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectTop2.vue?vue&type=script&lang=js"
import style0 from "./ThemeSettingsDirectTop2.vue?vue&type=style&index=0&id=553549d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553549d2",
  null
  
)

export default component.exports